import React, { ReactElement } from 'react';
import TablePaginationInternal from '@mui/material/TablePagination';
import useStylesTablePagination from './table-pagination.styles';
import {
  TABLE_LIMIT_MEDIUM, TABLE_LIMIT_SMALL, TABLE_LIMIT_DEFAULT, TABLE_LIMIT_LARGE,
} from '../../constants/system/table-limits';

const TablePagination: ReactMemoComponent = React.memo((props: ReactComponentProps): ReactElement => {
  const COMPONENT_DIV: TablePaginationComponent = 'div';

  const TABLE_LIMIT_OPTIONS: number[] = [
    TABLE_LIMIT_SMALL,
    TABLE_LIMIT_MEDIUM,
    TABLE_LIMIT_DEFAULT,
    TABLE_LIMIT_LARGE,
  ];

  const {
    page,
    limit,
    totalItems,
    onPageChange,
    onLimitChange,
  } = props;

  const { classes } = useStylesTablePagination();

  return (
    <TablePaginationInternal
      className={classes.tablePagination}
      classes={{
        actions: classes.tablePaginationActions,
        select: classes.tablePaginationSelect,
      }}
      rowsPerPageOptions={TABLE_LIMIT_OPTIONS}
      component={COMPONENT_DIV}
      count={totalItems || 0}
      rowsPerPage={limit}
      page={page}
      onPageChange={onPageChange}
      onRowsPerPageChange={(event: React.ChangeEvent<HTMLInputElement>): void => {
        onLimitChange(event.target.value);
      }}
    />
  );
});

export default TablePagination;
